import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 420px;
  }
  .text-pairing-title {
    max-width: 380px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 500px;
    }
  }
`;

export const ImageTextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 287px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
  .text-pairing-title {
    font-size: 24px;
    max-width: 287px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
`;

export const BorderdCircle = styled(Flex)`
  width: 50px;
  height: 50px;
  border: 3px solid #bbb1a3;
  box-sizing: border-box;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
`;

export const StyledTextImageColumn = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column-reverse;
  }
  ${themeMediaQuery('sm')} {
    min-width: 55rem;
  }
`;

export const StyledTextImageLeftColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    min-width: 55rem;
  }
`;

export const StyledTextPairFlex = styled(Flex)`
  width: 100%;
  align-items: center;
`;

export const StyledCloudImage = styled(CloudImage)<{ marginLeft?: string }>`
  width: 100%;
  height: 100%;
  max-height: 350px;
  max-width: 300px;
  min-height: 300px;
  min-width: 250px;
  object-fit: contain;
  margin-left: ${({ marginLeft }) => marginLeft || '0px'};
  ${themeMediaQuery('below_sm')} {
    margin-left: 0px;
  }
`;

export const VideoWrapper = styled(Box)`
  width: 440px;
  height: 343px;
  ${themeMediaQuery('below_sm')} {
    width: 330px;
    height: 257px;
  }
`;

export const StyledSectionHeader = styled(Box)`
  padding-top: ${themeSpace(12)};
  background: linear-gradient(180deg, ${themeColor('humana1Light')} 0%, rgba(255, 249, 245, 0) 80.08%);
  ${themeMediaQuery('below_sm')} {
    padding-top: ${themeSpace(9)};
  }
`;
